<app-truck-sidebar></app-truck-sidebar>
<div class="truck-owner-details">
    <div class="row">
        <div class="col-md-12 notifications-header">
            <h2>Notifications</h2>
        </div>
    </div>

    <div class="truck-owner-items">
        <div [class.spinner]="isLoading"></div>
        <div class="row to_container" *ngIf="notifications.length === 0 && !isLoading">
            <h4 class="error_msg">No Records Found.</h4>
        </div>

        <div class="row" *ngIf="notifications.length > 0 && !isLoading">
            <div class="col-xl-6 col-lg-6 col-md-12 mb-4 d-flex align-items-stretch" *ngFor="let note of notifications">

                <!-- 1. DRIVER APPROVAL CARD -->
                <mat-card class="notification-card w-100" *ngIf="note.type === 'DRIVER_APPROVAL'">
                    <div class="card-content-wrapper h-100">
                        <div class="type-indicator">
                            <div class="icon-circle driver-request">
                                <i class="fas fa-user-check"></i>
                            </div>
                        </div>
                        <div class="notification-main">
                            <div class="card-main-content">
                                <div class="card-header">
                                    <h3>{{ note.title }}</h3>
                                    <span class="created-at">{{ note.timestamp | date:'MMM d, y, h:mm a' }}</span>
                                </div>
                                <p class="message-text">{{ note.message }}</p>
                                <div class="details-grid">
                                    <div class="detail-item">
                                        <span class="detail-label">Driver Name</span>
                                        <span class="detail-value">{{ note.data.name }}</span>
                                    </div>
                                    <div class="detail-item" *ngIf="note.data.driver_mobile">
                                        <span class="detail-label">Phone</span>
                                        <span class="detail-value">{{ note.data.driver_mobile }}</span>
                                    </div>
                                    <div class="detail-item" *ngIf="note.data.driver_id">
                                        <span class="detail-label">Driver ID</span>
                                        <span class="detail-value">{{ note.data.driver_id }}</span>
                                    </div>
                                    <div class="detail-item" *ngIf="!note.data.driver_id && note.data.license">
                                        <span class="detail-label">License</span>
                                        <span class="detail-value">{{ note.data.license }}</span>
                                    </div>
                                </div>
                            </div>
                            <div class="card-actions">
                                <button class="btn-vibrant btn-outline" (click)="onRejectDriver(note)">Reject</button>
                                <button class="btn-vibrant btn-success" (click)="onAcceptDriver(note)">Accept</button>
                            </div>
                        </div>
                    </div>
                </mat-card>

                <!-- 2. QUOTE NOTIFICATION CARD -->
                <mat-card class="notification-card w-100"
                    *ngIf="note.type === 'QUOTE_CREATED' || note.type === 'ACTIVE_QUOTE'">
                    <div class="card-content-wrapper h-100">
                        <div class="type-indicator">
                            <div class="icon-circle quote-request">
                                <i class="fas fa-hand-holding-usd"></i>
                            </div>
                            <div class="expiry-countdown" *ngIf="note.data.expiresAt">
                                <i class="far fa-clock"></i>
                                <span>{{ note.data.countdown || '--:--' }}</span>
                            </div>
                        </div>
                        <div class="notification-main">
                            <div class="card-main-content">
                                <div class="card-header">
                                    <h3>{{ note.title }}</h3>
                                    <span class="created-at">{{ note.timestamp | date:'MMM d, y, h:mm a' }}</span>
                                </div>
                                <p class="message-text">{{ note.message }}</p>
                                <div class="route-info" *ngIf="note.data.from || note.data.to">
                                    <span class="location">{{ note.data.from || '---' }}</span>
                                    <i class="fas fa-long-arrow-alt-right route-arrow"></i>
                                    <span class="location">{{ note.data.to || '---' }}</span>
                                </div>
                                <div class="details-grid">
                                    <div class="detail-item">
                                        <span class="detail-label">Quote ID</span>
                                        <span class="detail-value">#{{ note.data.metadata?.quote_id || note.data.quoteId
                                            }}</span>
                                    </div>
                                    <div class="detail-item" *ngIf="note.data.pickupDate">
                                        <span class="detail-label">Pickup Date</span>
                                        <span class="detail-value pickup-date">{{ note.data.pickupDate |
                                            date:'mediumDate' }}</span>
                                    </div>

                                </div>
                            </div>
                            <div class="card-actions">
                                <button class="btn-vibrant btn-outline" (click)="onViewQuote(note)">Details</button>
                                <button class="btn-vibrant btn-primary" *ngIf="note.type === 'QUOTE_CREATED'"
                                    (click)="onBid(note)">Bid Now</button>
                            </div>
                        </div>
                    </div>
                </mat-card>

                <!-- 3. WORK ORDER CARD -->
                <mat-card class="notification-card w-100"
                    *ngIf="note.type === 'WORK_ORDER_CREATED' || note.type === 'ACTIVE_WO' || note.type === 'WO_ADD_TRUCK'">
                    <div class="card-content-wrapper h-100">
                        <div class="type-indicator">
                            <div class="icon-circle work-order">
                                <i class="fas fa-clipboard-list"></i>
                            </div>
                            <div class="expiry-countdown" *ngIf="note.data.expiresAt">
                                <i class="far fa-clock"></i>
                                <span>{{ note.data.countdown || '--:--' }}</span>
                            </div>
                        </div>
                        <div class="notification-main">
                            <div class="card-main-content">
                                <div class="card-header">
                                    <h3>{{ note.title }}</h3>
                                    <span class="created-at">{{ note.timestamp | date:'MMM d, y, h:mm a' }}</span>
                                </div>
                                <p class="message-text">{{ note.message }}</p>
                                <div class="route-info" *ngIf="note.data.from || note.data.to">
                                    <span class="location">{{ note.data.from || '---' }}</span>
                                    <i class="fas fa-long-arrow-alt-right route-arrow"></i>
                                    <span class="location">{{ note.data.to || '---' }}</span>
                                </div>
                                <div class="details-grid">
                                    <div class="detail-item">
                                        <span class="detail-label">WO ID</span>
                                        <span class="detail-value">#{{ note.data.metadata?.workorder_id ||
                                            note.data.woId }}</span>
                                    </div>
                                    <div class="detail-item" *ngIf="note.data.status">
                                        <span class="detail-label">Status</span>
                                        <span class="detail-value">{{ note.data.status }}</span>
                                    </div>
                                    <div class="detail-item" *ngIf="note.data.pickupDate">
                                        <span class="detail-label">Pickup Date</span>
                                        <span class="detail-value pickup-date">{{ note.data.pickupDate |
                                            date:'mediumDate' }}</span>
                                    </div>

                                </div>
                            </div>
                            <div class="card-actions">
                                <button class="btn-vibrant btn-outline" (click)="onViewWorkOrder(note)">View WO</button>
                                <button class="btn-vibrant btn-primary" *ngIf="note.type === 'WORK_ORDER_CREATED'"
                                    (click)="onBid(note)">Bid</button>
                                <button class="btn-vibrant btn-success" *ngIf="note.type === 'WO_ADD_TRUCK'"
                                    (click)="onAddTruck(note)">Add Truck</button>
                            </div>
                        </div>
                    </div>
                </mat-card>

                <!-- 4. RANKING UPDATED CARD -->
                <mat-card class="notification-card w-100" *ngIf="note.type === 'RANKING_UPDATED'">
                    <div class="card-content-wrapper h-100">
                        <div class="type-indicator">
                            <div class="icon-circle work-order"
                                style="background-color: var(--primary-light); color: var(--primary-color);">
                                <i class="fas fa-truck-loading"></i>
                            </div>
                            <div class="expiry-countdown" *ngIf="note.data.expiresAt">
                                <i class="far fa-clock"></i>
                                <span>{{ note.data.countdown || '--:--' }}</span>
                            </div>
                        </div>
                        <div class="notification-main">
                            <div class="card-main-content">
                                <div class="card-header">
                                    <h3>{{ note.title }}</h3>
                                    <span class="created-at">{{ note.timestamp | date:'MMM d, y, h:mm a' }}</span>
                                </div>
                                <p class="message-text">{{ note.message }}</p>
                                <div class="route-info" *ngIf="note.data.from || note.data.to">
                                    <span class="location">{{ note.data.from || '---' }}</span>
                                    <i class="fas fa-long-arrow-alt-right route-arrow"></i>
                                    <span class="location">{{ note.data.to || '---' }}</span>
                                </div>
                                <div class="details-grid">
                                    <div class="detail-item">
                                        <span class="detail-label">WO ID</span>
                                        <span class="detail-value">#{{ note.data.metadata?.workorder_name || note.data?.workorder_name
                                            }}</span>
                                    </div>
                                    <div class="detail-item" *ngIf="note.data.metadata?.bidRanking">
                                        <span class="detail-label">Ranking</span>
                                        <span class="detail-value">{{ note.data.metadata.bidRanking }}</span>
                                    </div>
                                    <div class="detail-item" *ngIf="note.data.pickupDate">
                                        <span class="detail-label">Pickup Date</span>
                                        <span class="detail-value pickup-date">{{ note.data.pickupDate |
                                            date:'mediumDate' }}</span>
                                    </div>
                                </div>
                            </div>
                            <div class="card-actions">
                                <button class="btn-vibrant btn-outline" (click)="onViewWorkOrder(note)">Details</button>
                                <button class="btn-vibrant btn-success" (click)="onAddTruck(note)">Add Truck</button>
                            </div>
                        </div>
                    </div>
                </mat-card>

                <!-- 5. GENERIC NOTIFICATION CARD -->
                <mat-card class="notification-card w-100"
                    *ngIf="!['DRIVER_APPROVAL', 'QUOTE_CREATED', 'ACTIVE_QUOTE', 'WORK_ORDER_CREATED', 'ACTIVE_WO', 'WO_ADD_TRUCK', 'RANKING_UPDATED'].includes(note.type)">
                    <div class="card-content-wrapper h-100">
                        <div class="type-indicator">
                            <div class="icon-circle generic-info">
                                <i class="fas fa-bell"></i>
                            </div>
                        </div>
                        <div class="notification-main">
                            <div class="card-main-content">
                                <div class="card-header">
                                    <h3>{{ note.title }}</h3>
                                    <span class="created-at">{{ note.timestamp | date:'MMM d, y, h:mm a' }}</span>
                                </div>
                                <p class="message-text">{{ note.message }}</p>
                            </div>
                        </div>
                    </div>
                </mat-card>

            </div>
        </div>
    </div>

</div>